<template>
  <table class="table ccb-project-table">
    <tr v-for="(field, index) in visibleFields" :key="index">
      <th>{{ field.question }}</th>
      <td class="fw-bold">
        <template v-if="Array.isArray(field.answer) && field.answer.length">
          <div v-for="(item, itemIndex) in field.answer" :key="itemIndex">
            {{ formatAnswerItem(item) }}
          </div>
        </template>
        <template v-else>{{ formatAnswerItem(field.answer) }}</template>
      </td>
    </tr>
  </table>
</template>

<script>
// Questions the backend returns but the slot must not show. "SOEID Analista"
// carries an encrypted blob appended to the name, so it is hidden as well.
const HIDDEN_QUESTIONS = ["destinatario", "soeid analista"];

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    visibleFields() {
      const form = Array.isArray(this.data.form) ? this.data.form : [];
      return form.filter(
        (field) =>
          !HIDDEN_QUESTIONS.includes(String(field.question || "").trim().toLowerCase())
      );
    },
  },
  methods: {
    // Answers come in mixed shapes: plain values, {label, value} selects and
    // arrays of catalog records whose first string property is the display text.
    formatAnswerItem(item) {
      if (item === null || item === undefined || item === "") return " - ";
      if (typeof item !== "object") return String(item);
      if (typeof item.label === "string" && item.label.trim()) return item.label.trim();
      const firstString = Object.values(item).find(
        (value) => typeof value === "string" && value.trim()
      );
      return firstString ? firstString.trim() : " - ";
    },
  },
};
</script>

<style lang="scss" scoped>
// Answers carry unbroken strings (encrypted soeid blobs) that would set the
// table's minimum width and force the slot to scroll horizontally.
.ccb-project-table {
  table-layout: fixed;
  width: 100%;

  th {
    width: 40%;
  }

  th,
  td {
    overflow-wrap: break-word;
  }
}
</style>
